if (!customElements.get('animated-search-text')) {
  customElements.define(
    'animated-search-text',
    class AnimatedSearchText extends window.BAO.CustomElement() {
      constructor () {
        super()
        this.currentIndex = 0
      }

      connectedCallback () {
        super.connectedCallback()

        this.showNextSpan()
        setInterval(this.showNextSpan.bind(this), 8000)
      }

      showNextSpan () {
        const spans = this.querySelectorAll('span')

        spans.forEach((span, index) => {
          span.classList.remove('visible')
          if (index === this.currentIndex) {
            span.classList.add('visible')
          }
        })

        this.currentIndex = (this.currentIndex + 1) % spans.length
      }
    },
  )
}
